// When max < min, the range is empty and min wins, e.g. a box larger than its container stays aligned to the container's start.
export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}
